import { DatePipe } from '@angular/common';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';

import { Subject, Subscription } from 'rxjs';
import { Report } from 'src/app/model';
import { ReportService, ToasterService } from 'src/app/services';
import * as moment from 'moment';

@Component({
  selector: 'app-add-interim-popup',
  templateUrl: './add-interim-popup.component.html',
  styleUrls: ['./add-interim-popup.component.scss']
})
export class AddInterimPopupComponent implements OnInit, OnDestroy {

  @ViewChild('addInterimForm') addInterimForm: NgForm;
  title: string = 'Add Interim';
  message: string = 'You are about to add Interim Date to Income Statements.';
  primaryButtonTitle: string = 'Add';
  public currentReport: Report;
  private reportSub: Subscription;
  subject: Subject<boolean>;
  toDayDate: string = '';
  maxDate: string = '';

  newInterimDate: string = '';

  constructor(public bsModalRef: BsModalRef,
    public reportService: ReportService,
    private datePipe: DatePipe,
    private toastr: ToasterService) {
    this.toDayDate = this.datePipe.transform(new Date().setDate(new Date().getDate() + 1), 'yyyy-M-d');
  }

  ngOnInit(): void {
    this.reportSub = this.reportService.report$.subscribe(currentReport => {
      this.currentReport = currentReport;
      if (this.currentReport?.LATEST?.FYE_DATE) {

        if (this.reportService.getForecastedDate()) {
          if (moment(this.reportService.getForecastedDate()).isBefore(this.toDayDate)) {
            this.maxDate = this.reportService.getForecastedDate();
          } else {
            this.maxDate = this.toDayDate;
          }  
        } else {
          this.maxDate = this.toDayDate;
        }

        if (this.currentReport.LATEST.FYE_DATE != this.currentReport.LATEST.RECENT_FINANCIAL_DATE) {
          this.newInterimDate = this.currentReport.LATEST.RECENT_FINANCIAL_DATE;
        }
      }
    });
  }

  ngOnDestroy(): void {
    if (this.reportSub)
      this.reportSub.unsubscribe();
  }

  submit() {
    this.toastr.info('Please wait a moment!');
    // let objFieldValue = new FieldValue();
    // objFieldValue.GROUP = 'REPORT_VERSION';
    // objFieldValue.FIELD = 'FYE_DATE';
    // objFieldValue.VALUE = this.currentReport.LATEST.FYE_DATE;
    // this.reportProvider.updateReportField(this.currentReport.LATEST.ID, objFieldValue).subscribe(res => {
    //   if (res.success) {
    this.currentReport.LATEST.RECENT_FINANCIAL_DATE = this.newInterimDate;
    this.bsModalRef.hide();
    this.subject.next(true);
    this.subject.complete();
    //   }
    // }, err => {
    //   // Error Handling
    // });

  }

  /** Cancel click */
  cancel() {
    this.bsModalRef.hide();
    this.subject.next(false);
    this.subject.complete();
  }

}
